// @flow
import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { applyPenders, type GenericResponseAction } from 'lib/common';
import {
  getEstimate,
  getEstimateBox,
  removeEstimate,
  removeEstimateBox,
  selectEstimateBox,
  updateEstimate,
} from 'lib/api/users';
import { createEstimateBoxSignedUrl, createEstimateSignedUrl } from 'lib/api/me';

const GET_ESTIMATE = 'estimate/GET_ESTIMATE';
const REMOVE_ESTIMATE = 'estimate/REMOVE_ESTIMATE';
const UPDATE_ESTIMATE = 'estimate/UPDATE_ESTIMATE';
const CREATE_ESTIMATE = 'estimate/CREATE_ESTIMATE';
const GET_ESTIMATE_BOX = 'estimate/GET_ESTIMATE_BOX';
const REMOVE_ESTIMATE_BOX = 'estimate/REMOVE_ESTIMATE_BOX';
const CREATE_ESTIMATE_BOX = 'estimate/CREATE_ESTIMATE';
const SELECT_ESTIMATE_BOX = 'estimate/SELECT_ESTIMATE_BOX';

export const actionCreators = {
  getEstimate: createAction(GET_ESTIMATE, getEstimate),
  removeEstimate: createAction(
    REMOVE_ESTIMATE,
    (username: string, estimateId: string) => estimateId,
    removeEstimate,
  ),
  updateEstimate: createAction(
    UPDATE_ESTIMATE,
    (username: string, estimateId: string, idx: number) => idx,
    updateEstimate,
  ),
  createEstimateSignedUrl: createAction(CREATE_ESTIMATE, createEstimateSignedUrl),
  getEstimateBox: createAction(GET_ESTIMATE_BOX, getEstimateBox),
  removeEstimateBox: createAction(
    REMOVE_ESTIMATE_BOX,
    (username: string, estimateId: string, idx: number) => idx,
    removeEstimateBox,
  ),
  createEstimateBoxSignedUrl: createAction(CREATE_ESTIMATE_BOX, createEstimateBoxSignedUrl),
  selectEstimateBox: createAction(SELECT_ESTIMATE_BOX, selectEstimateBox),
};

export type UploadInfo = {
  url: string,
  file_path: string,
  id: string,
};

export type GetEstimate = {
  data: any,
};

export type GetEstimateBox = {
  data: any,
};

export type RemoveEstimate = {
  estimateId: string,
};

export type UpdateEstimate = {
  idx: number,
};

export type RemoveEstimateBox = {
  idx: number,
};

type GetEstimateResponseAction = GenericResponseAction<GetEstimate, string>;
type GetEstimateBoxResponseAction = GenericResponseAction<GetEstimateBox, string>;
type RemoveEstimateResponseAction = GenericResponseAction<RemoveEstimate, string>;
type UpdateEstimateResponseAction = GenericResponseAction<UpdateEstimate, string>;
type RemoveEstimateBoxResponseAction = GenericResponseAction<RemoveEstimateBox, string>;
type SignedUrlResponseAction = GenericResponseAction<UploadInfo, string>;

export type EstimateState = {
  estimate: ?GetEstimate,
  estimateBox: ?GetEstimateBox,
  selectEstimateBox: ?GetEstimateBox,
  uploadInfo: ?UploadInfo,
};

const initialState: EstimateState = {
  estimate: null,
  estimateBox: null,
  selectEstimateBox: null,
  uploadInfo: null,
};

const reducer = handleActions(
  {
    [REMOVE_ESTIMATE]: (state, { payload: estimateId }: RemoveEstimateResponseAction) => {
      return produce(state, draft => {
        draft.estimate.data = draft.estimate.data.filter(t => t.id !== estimateId);
      });
    },
    [UPDATE_ESTIMATE]: (state, { payload: idx }: UpdateEstimateResponseAction) => {
      return produce(state, draft => {
        draft.estimate.data[idx].type = 'complete';
      });
    },
    [REMOVE_ESTIMATE_BOX]: (state, { payload: idx }: RemoveEstimateBoxResponseAction) => {
      return produce(state, draft => {
        draft.estimateBox.data[idx].response_id = null;
        draft.estimateBox.data[idx].response_path = null;
        draft.estimateBox.data[idx].response_created_at = null;
      });
    },
  },
  initialState,
);

export default applyPenders(reducer, [
  {
    type: GET_ESTIMATE,
    onSuccess: (state: EstimateState, action: GetEstimateResponseAction) => {
      return {
        ...state,
        estimate: action.payload.data,
      };
    },
  },
  {
    type: SELECT_ESTIMATE_BOX,
    onSuccess: (state: EstimateState, action: GetEstimateResponseAction) => {
      return {
        ...state,
        selectEstimateBox: action.payload.data,
      };
    },
  },
  {
    type: CREATE_ESTIMATE,
    onSuccess: (state: EstimateState, action: SignedUrlResponseAction) => {
      return {
        ...state,
        uploadInfo: action.payload.data,
      };
    },
  },
  {
    type: GET_ESTIMATE_BOX,
    onSuccess: (state: EstimateState, action: GetEstimateBoxResponseAction) => {
      return {
        ...state,
        estimateBox: action.payload.data,
      };
    },
  },
  {
    type: CREATE_ESTIMATE_BOX,
    onSuccess: (state: EstimateState, action: SignedUrlResponseAction) => {
      return {
        ...state,
        uploadInfo: action.payload.data,
      };
    },
  },
]);



// WEBPACK FOOTER //
// ./src/store/modules/estimate.js